module.exports = __webpack_public_path__ + "static/media/TV.b2ea7757.svg";